import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import React from 'react';
import { Link } from 'gatsby';
import styled from '@xstyled/styled-components';
export var InnerSiblingNavLink = styled.aBox(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 18;\n  transition: fast;\n  text-decoration: underline;\n  color: on-background-primary;\n\n  &:hover {\n    color: on-background-primary-dark;\n  }\n\n  &[data-type='next']:hover {\n    transform: translateX(2px);\n  }\n\n  &[data-type='previous']:hover {\n    transform: translateX(-2px);\n  }\n"])));
export var SiblingNavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var type = _ref.type,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "children"]);

  return /*#__PURE__*/React.createElement(InnerSiblingNavLink, Object.assign({
    ref: ref,
    forwardedAs: Link,
    "data-type": type,
    gridArea: type
  }, props), type === 'previous' && '← ', children, type === 'next' && ' →');
});
export var SiblingNav = styled.navBox(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-areas: 'previous next';\n  justify-content: space-between;\n  margin: 5 0;\n"])));